export default "__VITE_ASSET__jaV0bQNxHc1aw3IeBmOC5w__"